import { ALLERGY_TEXT, SEVERITY_TEXT } from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

export const AUDIT_LOG = 'Audit log'
export const NO_AUDIT_LOG = 'No audit logs'

export const text = {
  FIELD_REQUIRED_ALLERGY_ERROR: getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, ALLERGY_TEXT),
  FIELD_REQUIRED_SEVERITY_ERROR: getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, SEVERITY_TEXT),
  ALLERGY_UNIQUE_ERROR: getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE),
  ALLERGY_VALIDATION_ERROR: getUserFriendlyErrorMessage(errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED),
}
